// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production20Filled: FC<Production20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path
                d="M7.638 17.968a.42.42 0 0 0 .42.365h3.884a.421.421 0 0 0 .42-.365l.265-2.098a.416.416 0 0 1 .204-.307l.267-.156.008-.004.354-.197a.43.43 0 0 1 .374-.021l1.947.816a.426.426 0 0 0 .532-.175l1.943-3.32a.413.413 0 0 0-.11-.54l-1.706-1.278a.414.414 0 0 1-.167-.332v-.152c0-.077 0-.228.013-.57a.413.413 0 0 1 .166-.315l1.714-1.284a.412.412 0 0 0 .11-.54l-1.942-3.322a.426.426 0 0 0-.532-.175l-1.974.82a.422.422 0 0 1-.364-.017 8.683 8.683 0 0 1-.358-.203 11.73 11.73 0 0 0-.27-.16.422.422 0 0 1-.21-.312l-.264-2.094a.421.421 0 0 0-.42-.365H8.058a.42.42 0 0 0-.42.365l-.265 2.1a.418.418 0 0 1-.202.306l-.174.104-.14.08c-.113.067-.207.118-.32.178a.43.43 0 0 1-.367.018l-1.972-.82a.426.426 0 0 0-.532.175L1.723 7.495a.413.413 0 0 0 .11.54L3.54 9.313a.415.415 0 0 1 .167.331v.712c0 .13-.062.253-.167.332l-1.705 1.278a.413.413 0 0 0-.11.54l1.942 3.32a.426.426 0 0 0 .532.177l1.964-.817a.429.429 0 0 1 .38.025l.287.167.006.003.327.182c.117.065.195.18.212.312l.264 2.093ZM10 12.708a2.708 2.708 0 1 0 0-5.416 2.708 2.708 0 0 0 0 5.416Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production20Filled;
